import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default props => {
  const showMenu = () =>
    document.getElementById('dropDownMenu').classList.toggle('u-display--block')

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The object card is now the account card patterns. To use an actions
            variant of the account card, visit the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-action/design'}
            >
              Account Card - Actions
            </Link>{' '}
            page . To use an input variant, see the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-checkbox/design'}
            >
              {' '}
              Account Card - Checkbox
            </Link>
            ,{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-radio/design'}
            >
              Account Card - Radio
            </Link>{' '}
            or the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-select/design'}
            >
              Account Card - Select
            </Link>{' '}
            pages.
          </p>
        </Intro>
        {/* <Intro>
          <p>
            Object cards are used to list repeatable, related content, such as
            user accounts or addresses, where each card represents a discrete
            object. They are intended to create discernable visual patterns that
            are quickly recognized, so they should only represent one type of
            information within an experience. Object cards often appear in
            collections and should follow the same internal structure so they
            are easily scanned.
          </p>
        </Intro>

        <SectionTitle>Variants</SectionTitle>
        <Showcase
          full={true}
          site={data.site}
          title="Actions"
          text="Use this variant to display 1-3 actions associated with the information on the card as interactive icons with a label. Actions are always optional. The actions variant can also display an inline notification to give user feedback. If the notification is the only content within the obeject card, use it without a border."
        >
          <div class="card-wrapper">
            <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
              <div class="c-card__body--small u-flex-wrap--wrap">
                <div>
                  <a href="#" class="c-card__title--actionable">
                    Navigation Title
                    <span class="c-card__title-sub">...subtitle</span>
                    <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                  </a>
                </div>
                <div class="u-display--inline-block l-margin-right--large">
                  <div class="c-title-2--normal">Content Area</div>
                  <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                    Contextual Information
                  </div>
                  <a
                    href=""
                    class="c-icon-link u-type--xsmall u-display--inline"
                  >
                    <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                    What's this?
                  </a>
                </div>
              </div>
              <ul class="c-horizontal-list">
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--counter-directional"></i>
                    <span class="c-horizontal-list__text">Action 1</span>
                  </a>
                </li>
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--receipt"></i>
                    <span class="c-horizontal-list__text">Action 2</span>
                  </a>
                </li>
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--envelope-with-currency"></i>
                    <span class="c-horizontal-list__text">Action 3</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="card-wrapper">
            <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
              <div class="c-card__body--small u-flex-wrap--wrap">
                <div>
                  <a href="#" class="c-card__title--actionable">
                    Navigation Title
                    <span class="c-card__title-sub">...subtitle</span>
                    <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                  </a>
                </div>
                <div class="u-display--inline-block l-margin-right--large">
                  <div class="c-title-2--normal">Content Area</div>
                  <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                    Contextual Information
                  </div>
                  <a
                    href=""
                    class="c-icon-link u-type--xsmall u-display--inline"
                  >
                    <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                    What's this?
                  </a>
                </div>
              </div>
              <ul class="c-horizontal-list">
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--counter-directional"></i>
                    <span class="c-horizontal-list__text">Action 1</span>
                  </a>
                </li>
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--receipt"></i>
                    <span class="c-horizontal-list__text">Action 2</span>
                  </a>
                </li>
                <li class="c-horizontal-list__item">
                  <a href="" class="c-horizontal-list__link">
                    <i class="c-horizontal-list__icon icon icon--envelope-with-currency"></i>
                    <span class="c-horizontal-list__text">Action 3</span>
                  </a>
                </li>
              </ul>

              <div class="c-notification--inline-error l-margin--small">
                <div class="c-notification__icon">
                  <i class="icon icon--exclamation"></i>
                </div>
                <div class="c-notification__content">
                  Something went wrong with this object. Please fix it.
                </div>
              </div>
            </div>
          </div>
        </Showcase>

        <Showcase
          full={true}
          site={data.site}
          title="Select"
          text="The select variant is used to gather user input. The user can select a single object from a dropdown list of options. The entire container of the select object card is a hit area that triggers the dropdown. Do not use any other interactive components in a selected state."
        >
          <div class="card-wrapper">
            <div class="c-card__border-top">
              <div class="c-drop-down">
                <div class="c-drop-down__field">
                  <div class="c-drop-down__content">
                    <div class="u-display--inline-block l-margin-right--large">
                      <div class="c-title-2--normal u-color--primary-base u-type--bold">
                        Select an object
                      </div>
                      <div class="c-caption--normal">
                        Expand to see a list of available objects
                      </div>
                    </div>
                  </div>
                  <button
                    class="c-drop-down__toggle"
                    id="dropDownToggle"
                    onClick={() => showMenu()}
                  >
                    <i class="icon icon--arrow-without-tail-down"></i>
                  </button>
                </div>
                <div class="c-drop-down__menu" id="dropDownMenu">
                  <button class="c-drop-down__menu-item">
                    <span class="c-drop-down__menu-item-main">
                      Object 1 <span class="u-type--xsmall">...subtitle</span>
                    </span>
                    <span class="c-drop-down__menu-item-alt">Context</span>
                  </button>
                  <button class="c-drop-down__menu-item">
                    <span class="c-drop-down__menu-item-main">
                      Object 2 <span class="u-type--xsmall">...subtitle</span>
                    </span>
                    <span class="c-drop-down__menu-item-alt">Context</span>
                  </button>
                  <button class="c-drop-down__menu-item">
                    <span class="c-drop-down__menu-item-main">
                      Object 3 <span class="u-type--xsmall">...subtitle</span>
                    </span>
                    <span class="c-drop-down__menu-item-alt">Context</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>The select variant has both an empty state and an active state.</p>
        <Showcase
          site={data.site}
          title="Empty"
          text="Instead of displaying object information, the empty state uses a title and subtitle to invite the user to make a selection."
        >
          <div class="c-card__border-top">
            <div class="c-drop-down">
              <div class="c-drop-down__field">
                <div class="c-drop-down__content">
                  <div class="u-display--inline-block l-margin-right--large">
                    <div class="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an object
                    </div>
                    <div class="c-caption--normal">
                      Expand to see a list of available objects
                    </div>
                  </div>
                </div>
                <button class="c-drop-down__toggle" id="dropDownToggle">
                  <i class="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Active"
          text="In the active state, a dropdown presents input options with their own hover states, represented by a green bar. There is currently no limit on the number of objects shown in the dropdown. If the options extend off the screen, the dropdown container should stop and scroll within."
        >
          <div class="c-card__border-top">
            <div class="c-drop-down">
              <div class="c-drop-down__field">
                <div class="c-drop-down__content">
                  <div class="u-display--inline-block l-margin-right--large">
                    <div class="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an object
                    </div>
                    <div class="c-caption--normal">
                      Expand to see a list of available objects
                    </div>
                  </div>
                </div>
                <button class="c-drop-down__toggle" id="dropDownToggle">
                  <i class="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
              <div class="c-drop-down__menu u-display--block">
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Object 1 <span class="u-type--xsmall">...subtitle</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">Context</span>
                </button>
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Object 2 <span class="u-type--xsmall">...subtitle</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">Context</span>
                </button>
                <button class="c-drop-down__menu-item">
                  <span class="c-drop-down__menu-item-main">
                    Object 3 <span class="u-type--xsmall">...subtitle</span>
                  </span>
                  <span class="c-drop-down__menu-item-alt">Context</span>
                </button>
              </div>
            </div>
          </div>
        </Showcase>

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Object cards are designed to stack vertically. To reflect their visual
          pattern and enhance scannability, always place them on a fixed grid.
        </p>
        <p>
          At smaller breakpoints, the action variant will responsively list the
          available actions at the bottom of the card. To optimize touch
          interactions likely at these breakpoints, the select variant will
          trigger a full-screen modal that lists each available option as a
          populated object card instead of triggering a dropdown. Selecting an
          object within the list will exit the modal and bring the user back to
          the initial screen.
        </p>
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Action labels should use strong verbs and specific language, similar
          to{' '}
          <Link class="link" to={'/' + data.site + '/components/button/design'}>
            buttons
          </Link>{' '}
          . The empty state title and subtitle for the select variation should
          be simple CTAs, such as "Select a(n) [object]" and "Expand to see a
          list of available [objects]". Otherwise, follow the microcopy
          guidelines for the{' '}
          <Link class="link" to={'/' + data.site + '/components/link/design'}>
            icon links
          </Link>{' '}
          and{' '}
          <Link class="link" to={'/' + data.site + '/components/label/design'}>
            label
          </Link>{' '}
          components.
        </p> */}
      </Layout>
    </>
  )
}
